export default __webpack_public_path__ + "static/media/undraw_not_found_2.bdf1c60c.svg";